/**
 * Events Intelligems du projet (exemple Reglo / FullStack).
 * Ajouter un event : IntelligemsMetrics.register({ name, once, on })
 *
 * - name : identifiant Intelligems
 * - once : true = 1 seule fois (localStorage), false = à chaque trigger
 * - on   : event DOM (bubbles: true) — utiliser IntelligemsDomEvents pour les customs
 *
 * Sur un nouveau thème : partir de intelligems-custom-events.example.js
 */

import IntelligemsMetrics from '@theme/intelligems';
import { IntelligemsDomEvents } from '@theme/intelligems-events';

/* -------------------------------------------------------------------------- */
/* Events natifs du thème (ex. ThemeEvents FullStack)                         */
/* -------------------------------------------------------------------------- */

IntelligemsMetrics.register({
  name: 'productVariantSelect',
  once: false,
  on: 'variant:selected',
});

/* -------------------------------------------------------------------------- */
/* Events Intelligems (intelligems-events.js)                                 */
/* -------------------------------------------------------------------------- */

IntelligemsMetrics.register({
  name: 'productCarouselNavigate',
  once: false,
  on: IntelligemsDomEvents.productCarouselNavigate,
});

IntelligemsMetrics.register({
  name: 'productQuantityBreakSelect',
  once: false,
  on: IntelligemsDomEvents.quantityBreakSelected,
});

IntelligemsMetrics.register({
  name: 'productQuantityBreakVariantSelect',
  once: false,
  on: IntelligemsDomEvents.quantityBreakVariantSelected,
});

IntelligemsMetrics.register({
  name: 'productSubscriptionSelect',
  once: false,
  on: IntelligemsDomEvents.subscriptionOfferSelected,
});

IntelligemsMetrics.register({
  name: 'productAddToCart',
  once: false,
  on: IntelligemsDomEvents.productAddToCart,
});

IntelligemsMetrics.register({
  name: 'productGammeSelect',
  once: false,
  on: IntelligemsDomEvents.gammeSelectChange,
});

IntelligemsMetrics.register({
  name: 'productGammeProductSelect',
  once: false,
  on: IntelligemsDomEvents.productSelectorChange,
});
